import axios from "axios";
//axio实例

const http = axios.create({
    baseURL: 'http://jfkxadminapi.wxh5.net',
    timeout:10000
})

//请求拦截

http.interceptors.request.use((config)=>{
    //设置请求头
    // let token = localStorage.getItem('token');
    // if(token){
    //     config.headers.set('token',token)
    // }
   // 返回请求头
    return config

},err=>{
    return Promise.reject(err)
})

// 响应拦截
http.interceptors.response.use((res) => {
    // 响应成功则关闭loading加载

    //返回响应数据
    return res
}, err => {
    // 响应失败则关闭loading加载
    setTimeout(() => {

    }, 1000);
    // 响应失败返回失败信息
    return Promise.reject(err)
})

export default http



// WEBPACK FOOTER //
// ./src/api/http.js